<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UHLdEr/tc-custom/9781455603060.jpg?1726574163304" alt="This image is the cover for the book Crash of Little Eva"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crash of Little Eva
      </h1>
      <p class="bookDescription body article font2">
        <p>"A riveting read--the stuff of nightmares, perhaps, but testimony to the resilience of the human spirit, and I couldnï¿½t put it down." --Red Harrison, Weekend Australian</p><p>"Tales of human endurance and survival don't come much better than the one Barry Ralph tells." --Michael Jacobson, Gold Coast Bulletin</p><p>This tragic story is a moving account of the powers of human endurance. It recounts in authentic detail the fateful circumstances of Little Eva's last mission from a remote U.S. air base in Far North Queensland and follows the dedicated searchers and skilled trackers who risked their lives trying to save the lost crewmen.</p><p>On December 2, 1942, Little Eva, an American B-24 Liberator, went down in the Australian outback after a failed bombing mission over New Guinea. When the bombs failed to dislodge, pilot Capt. Norman Crosson decided to make a run for their secondary target after the bombardier made adjustments to the bomb bay. On the way to their secondary target, the plane ran into a severe storm and crashed, forcing the men to parachute into the unknown. Four men died in the crash, while six crewmen landed safely. The fate of the remaining six airmen and the attempts at finding them in the outback by Queensland Police, led by Constable Bob Hagarty, are faithfully researched and recounted in this story of survival.</p><p></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barry Ralph
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5340bc65